import type { FC, ReactNode } from "react";

export interface BaseCardProps {
  labelId?: string;
  title: ReactNode;
  children?: ReactNode;
}

export const BaseCard: FC<BaseCardProps> = (props) => {
  // ...

  return (
    <div className="flex flex-col gap-2 rounded-xl bg-white p-4 shadow-xs ring-1 ring-black/5">
      <div
        id={props.labelId}
        className="text-xs font-medium text-muted-foreground"
      >
        {props.title}
      </div>

      {props.children}
    </div>
  );
};
